<template>
  <div class="content">
    <div class="search_wrapper">
      <div class="search_head">
        <span>查询条件</span>
        <i
          class="searchDomw"
          @click="isSearchContent = !isSearchContent"
          :class="
            isSearchContent == true ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
          "
        ></i>
        <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="clearData"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
      </div>
      <div class="search_content" v-show="isSearchContent">
        <div class="search_inline">
          <el-form label-width="90px">
            <el-row>
              <el-col :span="5">
                <el-form-item label="医院名称">
                  <el-input
                    v-model="servicePointName"
                    placeholder="医院名称"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5" :offset="2">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  class="searchBtns"
                  @click="searchData"
                  >搜索</el-button
                >
                <el-button type="info" icon="el-icon-delete" @click="clearData"
                  >清除条件</el-button
                >
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div> -->
      </div>
    </div>
    <div class="table_title">
      <div class="btn_group">
        <el-button-group>
          <el-button
            type="success"
            icon="iconfont icon-xinzeng"
            class="openBtns"
            @click="handleTableForm('新增', 'add')"
            >新增</el-button
          >
        </el-button-group>
      </div>
      <!-- 筛选按钮 -->
      <div class="screen_container">
        <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            class="dropRests"
            @click="clearData"
          ></el-button>
          <!-- <el-button type="primary" style="padding: 10px 20px"> -->
          <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
            <span class="el-dropdown-link">
              <i class="el-icon-s-grid el-icon--right" style="color: #fff"></i>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="table_checkbox">
              <el-dropdown-item>
                <el-checkbox-group
                  v-model="tableChekbox"
                  @change="tableChekboxChange"
                >
                  <el-checkbox label="序号"></el-checkbox><br />
                  <el-checkbox label="医院名称"></el-checkbox><br />
                  <el-checkbox label="医院类型"></el-checkbox><br />
                  <el-checkbox label="服务热线"></el-checkbox><br />
                  <el-checkbox label="医疗床位数"></el-checkbox><br />
                  <el-checkbox label="运营模式"></el-checkbox><br />
                  <el-checkbox label="地址"></el-checkbox><br />
                  <el-checkbox label="状态"></el-checkbox><br />
                  <el-checkbox label="操作"></el-checkbox><br />
                </el-checkbox-group>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- </el-button> -->
        </el-button-group>
      </div>
    </div>
    <!-- tableb表格 -->
    <div class="table_container">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="550px"
        :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
        border
      >
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          v-if="this.tempTableChekbox.findIndex((item) => item == '序号') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="医院名称"
          align="center"
          prop="servicePointName"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '医院名称') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="医院类型"
          align="center"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '医院类型') != -1
          "
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.servicePointType == 0">街道养老服务中心</span>
            <span v-if="scope.row.servicePointType == 1">社区养老机构</span>
            <span v-if="scope.row.servicePointType == 2">小区养老服务点</span>
          </template>
        </el-table-column>
        <el-table-column
          label="服务热线"
          align="center"
          prop="servicePhone"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '服务热线') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="医疗床位数"
          align="center"
          prop="medicalBeds"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '医疗床位数') !=
            -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="运营模式"
          align="center"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '运营模式') != -1
          "
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.operatingModel == 0">公办公营</span>
            <span v-if="scope.row.operatingModel == 1">公办民营</span>
            <span v-if="scope.row.operatingModel == 2">民办民营</span>
          </template>
        </el-table-column>
        <el-table-column
          label="地址"
          align="center"
          prop="address"
          v-if="this.tempTableChekbox.findIndex((item) => item == '地址') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="状态"
          align="center"
          v-if="this.tempTableChekbox.findIndex((item) => item == '状态') != -1"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.reviewStatus == 0 || scope.row.reviewStatus == null
              "
              >未审核</span
            >
            <span v-if="scope.row.reviewStatus == 1">审核通过</span>
            <span v-if="scope.row.reviewStatus == 2">审核不通过</span>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          align="center"
          width="200px"
          fixed="right"
          v-if="this.tempTableChekbox.findIndex((item) => item == '操作') != -1"
        >
          <template slot-scope="scope">
            <span
              @click="handleTableForm('查看', scope.row)"
              style="margin-right: 12px; cursor: pointer"
              >查看</span
            >
            <span
              @click="handleTableForm('审核', scope.row)"
              v-if="scope.row.reviewStatus == 0"
              style="margin-right: 12px; cursor: pointer"
              >审核</span
            >
            <span
              @click="deleteItem(scope.row)"
              style="margin-right: 12px; cursor: pointer"
              >删除</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_container">
      <el-pagination
        :page-size="pageOne.pageSize"
        :current-page.sync="pageOne.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageOne.total"
        @size-change="handletableDataSize"
        @current-change="handleTableDataChange"
      ></el-pagination>
    </div>
    <person-open
      v-if="dialogVisible"
      :openData="dialogInfo"
      @cancleOpen="cancleOpen"
    ></person-open>
  </div>
</template>
<script>
import personOpen from "./personOpen"
export default {
  inject: ["reload"], //注入
  props: ["personData"],
  components: { personOpen },
  data() {
    return {
      servicePointName: "",
      isSearchContent: false,
      pageOne: { pageSize: 10, pageNo: 1, total: 0 },
      tableData: [],
      dialogVisible: false, //人员编辑
      dialogInfo: {},
      personState: false, //新增人员
      personInfo: {},
      radioId: "",
      tempTableChekbox: [
        "序号",
        "医院名称",
        "医院类型",
        "服务热线",
        "医疗床位数",
        "运营模式",
        "地址",
        "状态",
        "操作",
      ],
      tableChekbox: [
        "序号",
        "医院名称",
        "医院类型",
        "服务热线",
        "医疗床位数",
        "运营模式",
        "地址",
        "状态",
        "操作",
      ],
    }
  },
  created() {
    this.getList()
  },
  watch: {
    personData(old, news) {
      // console.log(old, news, this.personData, "组织id");
      this.getList()
    },
  },
  methods: {
    // 搜索
    searchData() {
      this.getList()
    },
    // 关闭人员信息弹窗
    cancleOpen(data) {
      this.dialogInfo = {}
      this.dialogVisible = false
      if (data == true) {
        this.getList()
      }
    },
    //删除表格信息
    deleteItem(date) {
      let params = {
        communityId: this.personData,
        id: date.id,
      }
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .request({
            url: "/ypt/admin/pensionServicePoint/info/deleteById",
            method: "POST",
            data: params,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功")
              // this.tableData = [];
              this.getList()
            }
          })
      })
    },
    // 当前页
    handleTableDataChange(val) {
      this.pageOne.pageNo = val
      this.getList()
    },
    // 分页大小
    handletableDataSize(val) {
      this.pageOne.pageSize = val
      this.getList()
    },
    // 选择列的展示方式
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    //重置
    clearData() {
      this.servicePointName = ""
      this.pageOne.pageSize = 10
      this.pageOne.pageNo = 1
      this.getList()
    },
    // 获取数据
    getList() {
      let params = {
        pageNo: this.pageOne.pageNo,
        pageSize: this.pageOne.pageSize,
        servicePointName: this.servicePointName,
        communityId: this.personData,
      }
      this.$http
        .request({
          url: "/ypt/admin/pensionServicePoint/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.pageOne.total = 0
              return
            }
            this.tableData = res.content.list
            this.pageOne.total = res.content.count
          }
        })
    },
    // 操作方法
    handleTableForm(title, row) {
      this.dialogVisible = true
      this.personState = false
      this.dialogInfo = {
        title: title,
        id: row.id,
        state: true,
        communityId: this.personData,
      }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.btn_group {
  margin-top: 0px !important;
}
/deep/.table_title {
  margin-top: 20px !important;
}

/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f1f2f6;
  box-shadow: 0 0 6px rgba(100, 100, 100, 0.16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    // display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw {
  cursor: pointer;
}
</style>
